import { Box, Fade, Flex, SimpleGrid, Spinner } from '@chakra-ui/react'
import BoxItem from './BoxItem'
import useListColors from '../../../../hooks/useListColors'
import { ItemData } from '../../../../context/MenuContext'
import { useEffect, useState } from 'react'
import { get } from '../../../../lib/http'
import { ListItemsProps } from './types'
import useMenu from '../../../../hooks/useMenu'
import useStorage from '../../../../hooks/useStorage'
import ModalModifiersItem from 'components/ModalModifiersItem'

export default function ListItems({
    categoryItemId,
    isLoading,
    setIsLoading
}: ListItemsProps & {
    isLoading: boolean
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
}) {
    const { getQuantity, addItem, addItemWithModifiers } = useMenu()
    const { get: getColor } = useListColors()
    const [categoryItems, setCategoryItems] = useState<ItemData[]>([])
    const { business_variables } = useStorage()

    const var_enabled_validation_stock = business_variables.find(
        v => v.code === '025'
    )?.value
    const enabled_validation_stock =
        var_enabled_validation_stock === '1' ? true : false

    async function load() {
        if (!categoryItemId) return
        setIsLoading(true)
        const result = await get<ItemData[]>(
            `/api/items?category_item_id=${categoryItemId || '0'}`
        )
        if (result.data) {
            setCategoryItems(result.data.result)
        }
        setIsLoading(false)
    }

    useEffect(() => {
        load()
    }, [categoryItemId])

    return (
        <Box
            w="full"
            p={{
                base: '4',
                lg: '5'
            }}
            bg="white"
            maxH={{
                base: 'calc(100vh - 260px)',
                lg: 'calc(100vh - 60px)'
            }}
            overflow="auto"
        >
            {isLoading && (
                <Flex justify="center" pt={10}>
                    <Spinner />
                </Flex>
            )}
            {!isLoading && (
                <Fade in>
                    <SimpleGrid
                        spacing={3}
                        minChildWidth={{
                            sm: '150px',
                            xl: '160px'
                        }}
                    >
                        {categoryItems.map((item, i) => (
                            <ModalModifiersItem
                                key={item.id}
                                itemId={item.id}
                                onDone={(
                                    _featureSelected,
                                    quantity,
                                    modifierGroupsSelected,
                                    _item_price_plus,
                                    _idGenerated,
                                    description
                                ) => {
                                    addItemWithModifiers(
                                        item,
                                        quantity,
                                        modifierGroupsSelected,
                                        description ?? ''
                                    )
                                }}
                                element={click => (
                                    <BoxItem
                                        key={i}
                                        bg={getColor(i)}
                                        quantity={getQuantity(item.id)}
                                        onClick={() => {
                                            if (item?.has_modifier_groups) {
                                                click()
                                            } else {
                                                addItem(item)
                                            }
                                        }}
                                        name={item.name}
                                        imageUrl={item.image_url}
                                        price={item.price}
                                        hasInventoryControl={
                                            item.has_inventory_control
                                        }
                                        inventory_management_type={
                                            item.inventory_management_type
                                        }
                                        stock={
                                            item.stock_production_item_simple
                                        }
                                        hasStock={
                                            !(
                                                item.stock_production_item_simple !==
                                                    null &&
                                                enabled_validation_stock &&
                                                item.stock_production_item_simple <=
                                                    0
                                            )
                                        }
                                    />
                                )}
                            />
                        ))}
                    </SimpleGrid>
                </Fade>
            )}
            {categoryItems.length === 0 && !isLoading && (
                <Box textAlign="center" color="gray-3">
                    No existen resultados
                </Box>
            )}
        </Box>
    )
}
